module.exports = __webpack_public_path__ + "img/weight-scale.3153e21e.svg";